import type { ReactDatePickerProps } from 'react-datepicker';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import { useTranslation } from 'react-i18next';
import { de, enGB, fr, nlBE } from 'date-fns/locale';

import { useFormatDate } from '@izimi/hooks';

import { DatePickerHeader } from './components/DatePickerHeader';
import { DatePickerInput } from './components/DatePickerInput';
import 'react-datepicker/dist/react-datepicker.css';

const defaultMaxDate = new Date();

registerLocale('fr', fr);
registerLocale('en', enGB);
registerLocale('nl', nlBE);
registerLocale('de', de);

type Props = {
  onChange: (date: Date) => void;
  onClear?: () => void;
  clearable?: boolean;
  label?: string;
} & Omit<
  ReactDatePickerProps,
  'onChange' | 'customInput' | 'renderCustomHeader' | 'showPopperArrow' | 'locale'
>;

export const DatePicker = ({
  onClear,
  clearable,
  label,
  maxDate = defaultMaxDate,
  ...props
}: Props) => {
  const { i18n } = useTranslation();
  const formatDate = useFormatDate(i18n.language);

  return (
    <ReactDatePicker
      customInput={<DatePickerInput onClear={onClear} clearable={clearable} label={label} />}
      renderCustomHeader={({ ...rest }) => <DatePickerHeader formatDate={formatDate} {...rest} />}
      maxDate={maxDate}
      dateFormat='dd/MM/yyyy'
      showPopperArrow={false}
      locale={i18n.language}
      {...props}
    />
  );
};
